import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

import {Box, Typography} from '@mui/material';

import {cultureAgentApiHost} from '../../../culture-agent/api';
import {CultureAgentResults} from '../../../culture-agent-results';

const API_HOST = cultureAgentApiHost();
const API_KEY = process.env.REACT_APP_CULTURE_AGENT_API_KEY ?? '';

export const ChatBasedTalentSurveyResultsPage = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const {sessionId} = location?.state?.params ?? {};

  return (
    <Box sx={{width: '100%', maxWidth: 1000, mx: 'auto', py: 3, px: 2}}>
      <Box sx={{textAlign: 'center', mb: 4}}>
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontSize: {xs: '36px', md: '48px', lg: '64px'},
            fontWeight: 700,
            lineHeight: '115%',
            color: '#000',
          }}
        >
          {t('talents.chatBasedSurvey.results.pageTitle')}
        </Typography>
      </Box>
      <CultureAgentResults
        config={{apiHost: API_HOST, apiKey: API_KEY, sessionId}}
        labels={{
          agentName: t('talents.chatBasedSurvey.agentName'),
          agentTitle: t('talents.chatBasedSurvey.agentTitle'),
          agentStatusLabel: t('talents.chatBasedSurvey.agentStatusLabel'),
          resultsLabel: t('talents.chatBasedSurvey.results.resultsLabel'),
          cultureReportBadge: t('talents.chatBasedSurvey.results.cultureReportBadge'),
          cultureTypeCardTitle: t('talents.chatBasedSurvey.results.cultureTypeCardTitle'),
          companyMatchHeading: t('talents.chatBasedSurvey.results.companyMatchHeading'),
          companyMatchDescription: t('talents.chatBasedSurvey.results.companyMatchDescription'),
          companyMatchInputPlaceholder: t('talents.chatBasedSurvey.results.companyMatchInputPlaceholder'),
          companyMatchResultHeading: (companyName) =>
            t('talents.chatBasedSurvey.results.companyMatchResultHeading', {companyName}),
          youLabel: t('talents.chatBasedSurvey.results.youLabel'),
          loading: t('talents.chatBasedSurvey.results.loading'),
          loadingMessages: [
            t('talents.chatBasedSurvey.results.loadingMessage1'),
            t('talents.chatBasedSurvey.results.loadingMessage2'),
            t('talents.chatBasedSurvey.results.loadingMessage3'),
            t('talents.chatBasedSurvey.results.loadingMessage4'),
            t('talents.chatBasedSurvey.results.loadingMessage5'),
          ],
          discoverMatchingJobs: t('talents.chatBasedSurvey.results.discoverMatchingJobs'),
          or: t('talents.chatBasedSurvey.results.or'),
          createAccount: t('talents.chatBasedSurvey.results.createAccount'),
        }}
      />
    </Box>
  );
};
